import React from 'react'
import { Button } from 'semantic-ui-react'
import Accordion from '../../common/Accordion'

export const LetterOfResignationFooter = ({
  expanded,
  setShow,
  handleDownload,
}) => {
  return (
    <Accordion
      heading="Your template letter is now ready"
      expanded={expanded}
      onClick={setShow}
    >
      <p>You can download your letter to your device.</p>
      <p>
        This will create a Word document that you can review and edit before you
        send it to your employee.
      </p>
      <h3>Important information</h3>
      <p>
        You should carefully check the terms in your Letter of resignation
        template. You may wish to seek professional advice to make sure they are
        suitable for your business.
      </p>
      <h3>Save to your device</h3>
      <Button className="ui is-primary button" onClick={handleDownload}>
        Download
      </Button>

      <p>
        Final pay is what an employer owes an employee when their employment
        ends. Your award, employment contract or enterprise agreement may
        specify when your final pay must be paid.
      </p>
      <p>
        Calculate any outstanding annual leave entitlements owed to full-time or
        part-time employees using our{' '}
        <a
          href="https://calculate.fairwork.gov.au/leave"
          target="_blank"
          rel="noreferrer"
          className="external-link"
        >
          Leave Calculator
        </a>{' '}
        .
      </p>
      <p>
        <a
          href="https://www.fairwork.gov.au/ending-employment/notice-and-final-pay/final-pay"
          target="_blank"
          rel="noreferrer"
          className="external-link"
        >
          Find out more about final pay
        </a>
        .
      </p>
    </Accordion>
  )
}
